import {axiosGetHandler, axiosPostHandler} from '_root/miniprogram/common/request.js'

/**
 * 获取手机号SID
 * @param { code } args 验证码
 * @param { phone_num } formdata 加密过的带国家代码的手机号
 * @returns { result: { sid } }
 */
export function MPGetPhoneNumSid (args, formdata) {
	let url = '/account/get_phonenum_sid/'
	return axiosPostHandler(url, args, formdata, 'heybox')
}

// 绑定手机号
export function MPBindPhoneNum (args, formdata) {
	var url = '/account/web_bind_phonenum'
	return axiosPostHandler(url, args, formdata, 'heybox')
}

// 获取用户游戏id
export function MPGetUserGameIds (args) {
	var url = '/chatroom/v2/account/user_game_ids'
	return axiosGetHandler(url, args, 'heychat')
}

// 获取自己游戏状态
export function MPGetSelfGameState (args) {
	let url = '/chatroom/v2/account/game_state'
	return axiosGetHandler(url, args, 'heychat')
}

// 获取个人信息
export function MPGetAccountInfo (args, formdata) {
	let url = '/account/info/'
	return axiosPostHandler(url, args, formdata, 'heybox')
}

// 更新或者插入新的card
export function MPUpsertCard (args, formdata) {
	var url = '/chatroom/v2/account/card/upsert'
	return axiosPostHandler(url, args, formdata, 'heychat')
}